// @flow
export type DurationBounds = {
  minDuration?: ?number,
  maxDuration?: ?number,
};

export const getDurationBounds = (
  values?: ?DurationBounds
): { minDuration: ?number, maxDuration: ?number } => ({
  minDuration: values?.minDuration ?? null,
  maxDuration: values?.maxDuration === 0 ? null : values?.maxDuration ?? null,
});

// Wall-clock only (picker dates are sentinels); keep seconds for CSV bounds.
const getWallClockSeconds = (date: Date): number =>
  date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();

export const getClassDuration = (start: Date, end: Date): number =>
  (getWallClockSeconds(end) - getWallClockSeconds(start)) / 60;

export const getDurationError = (
  duration: ?number,
  bounds?: DurationBounds
): ?string => {
  const { minDuration, maxDuration } = getDurationBounds(bounds);

  if (
    (minDuration !== null &&
      (!Number.isSafeInteger(minDuration) || minDuration < 0)) ||
    (maxDuration !== null &&
      (!Number.isSafeInteger(maxDuration) || maxDuration < 0)) ||
    (minDuration !== null && maxDuration !== null && minDuration > maxDuration)
  ) {
    return "The selected class has invalid duration limits";
  }

  if (duration === null || duration === undefined) {
    return null;
  }

  if (duration <= 0) {
    return "End time must be after start time";
  }

  if (minDuration !== null && duration < minDuration) {
    return `Class must be at least ${minDuration} minutes long`;
  }

  if (maxDuration !== null && duration > maxDuration) {
    return `Class must be no longer than ${maxDuration} minutes`;
  }

  return null;
};
